import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import React, { useState } from 'react';

import {
  DayPickerSingleDateController,
  DayPickerSingleDateControllerShape,
} from 'react-dates';
import moment, { Moment } from 'moment';

type RequiredProps = 'focused' | 'onFocusChange' | 'initialVisibleMonth';

export type DayPickerSingleDateControllerProps = Omit<
  DayPickerSingleDateControllerShape,
  RequiredProps | 'renderMonthText'
> &
  Partial<Pick<DayPickerSingleDateControllerShape, RequiredProps>>;

import CustomIcon from '@components/utils/CustomIcon';
import { ChevronLeft, ChevronRight } from '@assets/icons';

import {
  DatePickerWrapper,
  NavNextButton,
  NavPrevButton,
} from '../DatePickerStyle';

const SingleDatePicker = (props: DayPickerSingleDateControllerProps) => {
  const [focused, setFocused] = useState(true);

  const onFocusChange = () => {
    setFocused(true);
  };

  return (
    <DatePickerWrapper>
      <DayPickerSingleDateController
        {...props}
        numberOfMonths={2}
        renderNavPrevButton={(props) => (
          <NavPrevButton
            variant='Text'
            {...(props as React.ButtonHTMLAttributes<HTMLButtonElement>)}
          >
            <CustomIcon
              icon={ChevronLeft}
              fontSize={12}
              paletteColor='darkGray'
            />
          </NavPrevButton>
        )}
        renderNavNextButton={(props) => (
          <NavNextButton variant='Text' {...props}>
            <CustomIcon
              icon={ChevronRight}
              fontSize={12}
              paletteColor='darkGray'
            />
          </NavNextButton>
        )}
        initialVisibleMonth={null}
        daySize={33}
        orientation='horizontal'
        focused={focused}
        onFocusChange={onFocusChange}
      />
    </DatePickerWrapper>
  );
};

export const dateRangePickerDefaultProps: DayPickerSingleDateControllerProps = {
  focused: false,
  onFocusChange: () => false,
  date: null,
  onDateChange: () => false,
  isOutsideRange: (day: Moment) => day <= moment(),
  initialVisibleMonth: null,
  verticalBorderSpacing: 3,
  withPortal: false,
  keepOpenOnDateSelect: false,
  isRTL: false,
  enableOutsideDays: false,
  hideKeyboardShortcutsPanel: true,
  monthFormat: 'MMMM YYYY',
};

SingleDatePicker.defaultProps = dateRangePickerDefaultProps;
export default SingleDatePicker;
